import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

const MarkdownRenderer = ({ markdown }) => {
  // Convert markdown to HTML and sanitize it.
  const createMarkup = () => {
    const rawHTML = marked(markdown);
    return { __html: DOMPurify.sanitize(rawHTML) };
  };

  return <div dangerouslySetInnerHTML={createMarkup()} />;
};

export default MarkdownRenderer;